<div class="detalle__movimiento">
    <div class="detalle__title-2">
        <h2>Movimientos</h2>
        <p *ngIf="errorMensaje" class="alert red">{{errorMensaje}}</p>
        <div class="btn-group">
            <label>Últimos</label>
            <select #selectFiltro (change)="changeFilter(selectFiltro.value)">
                <option value="30">30 Días</option>
                <option value="60">60 Días</option>
                <option value="90">90 Días</option>
            </select>
        </div>
    </div>
    <div class="movimientos movimientosComponent">
        <div class="movimientos__items">
            <div>
                <h2>N&deg; Transacción</h2>
            </div>
            <div>
                <h2>Tipo</h2>
            </div>
            <div>
                <h2>Fecha</h2>
            </div>
            <div>
                <h2>Lugar</h2>
            </div>
            <div>
                <h2>Vehiculo</h2>
            </div>
            <div>
                <h2>Monto</h2>
            </div>
                        <div>
                <h2>Saldo</h2>
            </div>
        </div>
        <ng-container *ngIf="this.movimientos?.listaTransacciones.length > 0; else noResult">
            <div *ngFor="let data of this.movimientos.listaTransacciones;let i = index"
                class="movimientos__items content">
                <div class="body">
                    <h2>N&deg; Transacción</h2>
                    <p>{{i + 1}}</p>
                </div>
                <div class="date">
                    <h2>Tipo</h2>
                    <p>{{data.nombreTRX}}</p>
                </div>
                <div class="body">
                    <h2>Fecha</h2>
                    <p>{{data.fecha_trx}}</p>
                </div>
                <div class="body">
                    <h2>Lugar</h2>
                    <p>{{comproboTrx(data)}}</p>
                </div>
                <div class="body">
                    <h2>Vehiculo</h2>
                    <p>{{comproboVehi(data)}}</p>
                </div>
                <div class="body">
                    <h2>Monto</h2>
                    <p>
                        {{monto(data)}}
                    </p>
                </div>
                <div class="saldo">
                    <h2>Saldo</h2>
                    <p>{{data.saldoTrx}}</p>
                </div>
            </div>
        </ng-container>
        <ng-template #noResult>
            <div class="movimientos__items content">
                <div class="body">
                    <span *ngIf="movimientos.estado != 0 ">{{movimientos.mensaje}}</span>
                    <span *ngIf="movimientos.estado == 0 ">Esta tarjeta no posee movimientos</span>

                </div>
            </div>
        </ng-template>
    </div>
</div>